import React, { useState } from 'react'
import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import {Route, Routes} from "react-router-dom";

const CreateRequest = () => {
    return (
        <>
    
            <Routes>
                <Route path='/*' element={<Step1/>}/>
                <Route path='/request-pricing/' element={<Step2/>}/>
                <Route path='/request-overview/' element={<Step3/>}/>
            </Routes>
      
        </>
    )
}

export default CreateRequest